import { render, staticRenderFns } from "./PluginDisqus.vue?vue&type=template&id=3f4d79cf"
import script from "./PluginDisqus.vue?vue&type=script&lang=js"
export * from "./PluginDisqus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f4d79cf')) {
      api.createRecord('3f4d79cf', component.options)
    } else {
      api.reload('3f4d79cf', component.options)
    }
    module.hot.accept("./PluginDisqus.vue?vue&type=template&id=3f4d79cf", function () {
      api.rerender('3f4d79cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/plugins/PluginDisqus.vue"
export default component.exports